module.exports = __webpack_public_path__ + "img/search-active.37e1bfee.svg";